import React from 'react'
import { Button } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { closeVideo } from '../../redux/actions/videoActions.jsx'


class Player extends React.Component {

  // constructor(props) {
  //   super(props)
  // }

  closeVideo() {
    this.props.dispatch(closeVideo())
  }

  goFullscreen() {
  //   var element = document.getElementById('iframe-video-player');
  //   if (element.mozRequestFullScreen) {
  //     element.mozRequestFullScreen();
  //   } else if (element.webkitRequestFullScreen) {
  //     element.webkitRequestFullScreen();
  //  }
  }

  componentDidMount() {
    this.goFullscreen()
  }

  render() {
    return (
      <div className='video-player'>
        {this.props.currentVideo
          ? <div>
              <div className='iframe-holder'>
                <iframe id="iframe-video-player" title='currentVideo' width="736" height="414" src={this.props.currentVideo.url} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />
              </div>
              <h4>Click <a href={this.props.currentVideo.url} target="_blank">here</a> for the video URL
              </h4>
            </div>
          : null
        }
      </div>
    )
  }
}

export default connect(store => {
  return { currentVideo: store.currentVideo.video }
})(Player)